// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-updated {
  font-size: 0.8rem;
  border-bottom: 1px solid #ddd;
  text-align: right;
  color: white;
}
.card-updated-success {
  background-color: #28a745;
  padding: 4px 16px;
  display: block;
}
.card-updated-fail {
  background-color: #db3545;
  padding: 4px 16px;
  display: block;
}

fa:hover {
  cursor: pointer;
}

.card {
  box-shadow: 0 0 -10px 10px #333;
}`, "",{"version":3,"sources":["webpack://./src/app/components/card/card.component.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,6BAAA;EACA,iBAAA;EACA,YAAA;AACF;AACE;EACE,yBAAA;EACA,iBAAA;EACA,cAAA;AACJ;AAEE;EACE,yBAAA;EACA,iBAAA;EACA,cAAA;AAAJ;;AAIA;EACE,eAAA;AADF;;AAIA;EACE,+BAAA;AADF","sourcesContent":[".card-updated {\n  font-size: 0.8rem;\n  border-bottom: 1px solid #ddd;\n  text-align: right;\n  color: white;\n\n  &-success {\n    background-color: #28a745;\n    padding: 4px 16px;\n    display: block;\n  }\n\n  &-fail {\n    background-color: #db3545;\n    padding: 4px 16px;\n    display: block;\n  }\n}\n\nfa:hover {\n  cursor: pointer;\n}\n\n.card {\n  box-shadow: 0 0 -10px 10px #333;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
